 import React, { useEffect, useState } from 'react'
 import data from '../experience.json'
 
 export default function ExperienceCard() {
     const [Experiences, setExperiences] = useState([])

     useEffect(()=>{
         setExperiences(data)
     },[])
     const styleDiv = {
        boxShadow:"2px 2px 4px grey",
        padding:"10px",
        margin:"10px", 
    }
     return (
         <>
           {
               Experiences.map(experience =>{
                  return (
                      <div style={styleDiv} key={experience.id}>
                          <h2>{experience.role}</h2>
                          <h3>{experience.company}</h3>
                          <h4><i>{experience.time_period}</i></h4>
                          <p>{experience.description}</p>
                      </div>
                  )
               })
           }  
         </>
     )
 }
 